import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@src/v3/components/coreUI/carousel';
import PropertyCardCompact from '@src/v3/components/propertyCard/propertyCardCompact';
import { MarkerPropertyData } from '@src/v3/interfaces/components/coreUI/googleMap';
import { APP_ROUTE } from '@src/v3/constants/routes';
import { cn } from '@src/v3/lib/utils';

interface MarkerPropertySliderProps {
  /** Array of property data to display */
  properties: MarkerPropertyData[] | null;
  /** Whether the slider is visible */
  isVisible: boolean;
  /** Bottom offset in pixels (to position above navbar) */
  bottomOffset?: number;
}

const MarkerPropertySlider: React.FC<MarkerPropertySliderProps> = ({
  properties,
  isVisible,
  bottomOffset = 80,
}) => {
  if (!properties || properties.length === 0) {
    return null;
  }

  return (
    <div
      className={`fixed inset-x-0 z-[55] transition-transform duration-300 ease-out ${
        isVisible ? 'translate-y-0' : 'translate-y-full pointer-events-none'
      }`}
      style={{ bottom: `${bottomOffset}px` }}
    >
      <div className="overflow-hidden">
        <Carousel
          className="w-full"
          opts={{
            align: properties?.length === 1 ? 'center' : 'start',
            loop: false,
          }}
        >
          <CarouselContent className="ml-0">
            {properties.map((property) => (
              <CarouselItem
                key={property.id}
                className={cn(
                  properties.length > 1
                    ? 'basis-[320px] pl-4 last:pr-4'
                    : 'basis-full px-4'
                )}
              >
                <PropertyCardCompact
                  widthClassName={`${
                    properties.length > 1 ? 'w-80vw' : 'w-100vw'
                  } `}
                  image={property.image}
                  address={property.address}
                  locationDetails={property.locationDetails}
                  price={property.cost}
                  netEffectiveRent={property.netEffectiveRent}
                  bedroom={property.bedrooms}
                  bathroom={property.bathrooms}
                  squareFootage={property.squareFootage}
                  href={APP_ROUTE.PROPERTY?.replace(
                    '#PROPERTY_ID#',
                    property.id
                  )}
                  variant="singleUnit"
                />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
    </div>
  );
};

export default MarkerPropertySlider;
